import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import ProtectedRoute from '@/components/auth/ProtectedRoute';
import Layout from '@/components/layout/Layout';
import Landing from '@/pages/Landing';
import Home from '@/pages/Home';
import Login from '@/pages/Login';
import Register from '@/pages/Register';
import RegisterPromo from '@/pages/RegisterPromo';
import CreateSnap from '@/pages/CreateSnap';
import SnapDetails from '@/pages/SnapDetails';
import Profile from '@/pages/Profile';
import UserProfile from '@/pages/UserProfile';
import Settings from '@/pages/Settings';
import Privacy from '@/pages/legal/Privacy';
import Terms from '@/pages/legal/Terms';
import Imprint from '@/pages/legal/Imprint';
import Cookies from '@/pages/legal/Cookies';
import Pricing from '@/pages/Pricing';
import About from '@/pages/About';
import Contact from '@/pages/Contact';
import SnapFeed from '@/pages/SnapFeed';
import Credits from '@/pages/Credits';
import CashSnaps from '@/pages/CashSnaps';
import CashSnapAdmin from '@/pages/admin/CashSnapAdmin';
import AgeVerification from '@/pages/AgeVerification';
import { useAuth } from '@/context/AuthContext';

// ✅ Admin-Route-Absicherung hinzufügen
import ProtectedAdminRoute from '@/components/auth/ProtectedAdminRoute';

export default function AppRoutes() {
  const { user } = useAuth();
  const location = useLocation();

  useEffect(() => {
    if (user) {
      const redirectSnapId = localStorage.getItem('redirectSnapId');
      if (redirectSnapId && location.pathname === '/login') {
        localStorage.removeItem('redirectSnapId');
        window.location.href = `/snap/${redirectSnapId}`;
      }
    }
  }, [user, location.pathname]);

  useEffect(() => {
    if (!user) {
      const snapMatch = location.pathname.match(/^\/snap\/([a-f0-9-]+)$/i);
      if (snapMatch && snapMatch[1]) {
        localStorage.setItem('redirectSnapId', snapMatch[1]);
      }
    }
  }, [user, location.pathname]);

  return (
    <Routes>
      {/* Public Routes */}
      <Route path="/" element={<Landing />} />
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/registerPromo" element={<RegisterPromo />} />

      {/* Public Pages with Layout */}
      <Route element={<Layout />}>
        <Route path="/pricing" element={<Pricing />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/imprint" element={<Imprint />} />
        <Route path="/cookies" element={<Cookies />} />
        <Route path="/conditions" element={<CashSnaps />} />
        <Route path="/cashsnaps" element={<CashSnaps />} />

        {/* Protected Routes */}
        <Route element={<ProtectedRoute />}>
          <Route path="/dashboard" element={<Home key="dashboard" />} />
          <Route path="/create" element={<CreateSnap />} />
          <Route path="/snap/:id" element={<SnapDetails />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/user/:id" element={<UserProfile />} />
          <Route path="/settings" element={<Settings />} />
          <Route path="/feed" element={<SnapFeed />} />
          <Route path="/credits" element={<Credits />} />
          <Route path="/verify-age" element={<AgeVerification />} />
          
          {/* ✅ Nur für Admins */}
          <Route
            path="/admin/cashsnaps"
            element={
              <ProtectedAdminRoute>
                <CashSnapAdmin />
              </ProtectedAdminRoute>
            }
          />
        </Route>
      </Route>

      {/* Fallback */}
      <Route path="*" element={<Navigate to={user ? "/dashboard" : "/"} replace />} />
    </Routes>
  );
}
